module.exports = __webpack_public_path__ + "img/4season-2.32aa49ca.png";